import apiClient from "../config/apiClient";
import { API_ENDPOINTS } from "../config/endpoints";
import { handleApiError } from "../config/errorHandler";

/**
 * Company Address Create API Call
 * @param {Object} addressData - { company_id, address_type, country_id, restaurant_id, branch_id, block, street, additional_direction, country_code, mobile_number, house_no, apartment_no, building, floor, company_name, avenue, address_label, latitude, longitude }
 * @returns {Promise<Object>} - Response data from the API
 */
export const companyAddressCreate = async (addressData) => {
  try {
    const response = await apiClient.post(API_ENDPOINTS.COMPANY_ADDRESS_CREATE, addressData);
    
    return response.data;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
}; 